<template>

  <div>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title rt-op">
              Register Payment/Refund
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-card class="register__payment-card retail_order__payment-card">
      <b-row class="content-header">
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="6"
        >
          <b-media
            no-body
            class="register__payment-left-media"
          >
            <b-media-aside class="register__payment-left-media-icon">
              <b-avatar
                size="40"
                variant="light-primary"
                rounded
              >
                <img :src="dollarPlusIcon">
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto register__payment-left-media-text">
              <b-card-text class="font-small-3 mb-0 text-primary text-uppercase">
                Making Payment For
              </b-card-text>
              <h4 class="mb-0">
                {{ order.stringID }} - {{ order.customerName }}
              </h4>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          v-if="order._id"
          class="content-header-right register__payment-right-media-wrapper"
          md="6"
          cols="12"
        >
          <b-media
            no-body
            class="register__payment-right-media"
          >
            <b-media-aside class="register__payment-right-media-icon">
              <b-avatar
                size="48"
                variant="light-success"
              >
                <img :src="handIcon">
              </b-avatar>
            </b-media-aside>
            <b-media-body class="register__payment-right-media-text">
              <h4 class="font-weight-bolder mb-0">
                ${{ numberFormat(order.amountPaid) }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Previously Paid
              </b-card-text>
            </b-media-body>
          </b-media>
          <b-media
            no-body
            class="register__payment-right-media"
          >
            <b-media-aside class="register__payment-right-media-icon">
              <b-avatar
                size="48"
                :variant="totalOutstanding < 0 ? 'light-info' : 'light-warning'"
              >
                <feather-icon
                  size="24"
                  icon="DollarSignIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="register__payment-right-media-text">
              <h4
                class="font-weight-bolder mb-0"
                :class="totalOutstanding < 0 ? 'text-info' : ''"
              >
                {{ totalOutstandingLabel }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Total Outstanding
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>

      <hr class="dividerHR">
      <div class="payment_container">
        <validation-observer
          ref="registerPaymentForm"
          #default="{ invalid }"
        >
          <b-form @submit.prevent="openConfirmModal">
            <b-row>
              <b-col
                md="6"
                cols="12"
              >
                <div class="order_no_block">
                  <b-form-group
                    label="Order No."
                    label-class="register__payment-label"
                    label-for="orderNo"
                  >
                    <b-form-input
                      id="orderNo"
                      :value="order.stringID"
                      readonly
                    />
                  </b-form-group>
                </div>
              </b-col>

              <b-col
                md="6"
                cols="12"
              >
                <div class="payment_right_part">
                  <div class="payment_amount_block">
                    <b-form-group
                      label="Amount to be Paid*"
                      label-class="register__payment-label"
                      label-for="amountToBePaid"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Amount to be Paid"
                        vid="amountToBePaid"
                        rules="required"
                      >
                        <b-input-group
                          prepend="$"
                          class="input-group-merge payment__card-large-input-prepend"
                        >
                          <b-form-input
                            id="amountToBePaid"
                            v-model="amountToBePaid"
                            class="payment__card-large-input"
                            type="number"
                            step="0.01"
                            :state="errors.length > 0 ? false : null"
                            placeholder="0.00"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <div
                    v-if="isRefund"
                    class="refund-for-box mb-2"
                  >
                    <p class="register__payment-label mb-50">
                      Refund For
                    </p>
                    <b-form-radio-group
                      v-if="refundableTransactions.length"
                      v-model="selectedRefundTransactionId"
                      stacked
                    >
                      <div
                        v-for="(trx, index) in refundableTransactions"
                        :key="trx._id"
                        class="d-flex justify-content-between align-items-center mb-50"
                      >
                        <span class="label_index">{{ index + 1 }}</span> {{ trx.stringID }}
                        <span class="ml-1">${{ numberFormat(trx.amount) }}</span>
                      </div>
                    </b-form-radio-group>
                    <div
                      v-else
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span class="label_index">{{ index + 1 }}</span> {{ order.stringID }}
                      <span class="ml-1">${{ numberFormat(order.amountPaid) }}</span>
                    </div>
                  </div>

                  <div
                    v-else-if="totalOutstanding > 0"
                    class="refund-for-box mb-2"
                  >
                    <p class="register__payment-label mb-50">
                      Payment For
                    </p>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="label_index">1</span> {{ order.stringID }}
                      <span class="ml-1">${{ numberFormat(totalOutstanding) }}</span>
                    </div>
                  </div>

                  <b-form-group
                    label="Payment Mode*"
                    label-for="payment-mode"
                    label-class="register__payment-label"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Payment Mode"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="paymentMode"
                        buttons
                        button-variant="outline-primary"
                        class="spaceBetweenRadio equal_widthRadio"
                        @change="onPaymentModeChange"
                      >
                        <b-form-radio
                          value="Card"
                          class="register__payment-icon-checkbox"
                        >
                          <img
                            :src="cardIcon"
                            class="register__payment-icon"
                          >
                          <br>
                          <span class="register__payment-text">Card</span>
                        </b-form-radio>
                        <b-form-radio
                          value="Cash"
                          class="register__payment-icon-checkbox"
                        >
                          <img
                            :src="dollarIcon"
                            class="register__payment-icon"
                          >
                          <br>
                          <span class="register__payment-text">Cash</span>
                        </b-form-radio>
                        <b-form-radio
                          value="GIRO"
                          class="register__payment-icon-checkbox"
                        >
                          <img
                            :src="giroIcon"
                            class="register__payment-icon"
                          >
                          <br>
                          <span class="register__payment-text">GIRO</span>
                        </b-form-radio>
                        <b-form-radio
                          value="NETS"
                          class="register__payment-icon-checkbox"
                        >
                          <img
                            :src="netsIcon"
                            class="register__payment-icon"
                          >
                          <br>
                          <span class="register__payment-text">NETS</span>
                        </b-form-radio>
                        <b-form-radio
                          value="Cheque"
                          class="register__payment-icon-checkbox"
                        >
                          <img
                            :src="chequeIcon"
                            class="register__payment-icon"
                          >
                          <br>
                          <span class="register__payment-text">Cheque</span>
                        </b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group v-if="paymentMode === 'Card'">
                    <validation-provider
                      #default="{ errors }"
                      name="Payment Option"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="cardOption"
                        buttons
                        button-variant="outline-primary"
                        class="spaceBetweenRadio radiogGap10"
                        @change="onPaymentOptionChange"
                      >
                        <b-form-radio
                          value="IPP"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">IPP</span>
                        </b-form-radio>
                        <b-form-radio
                          value="Direct Debit"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">Direct Debit</span>
                        </b-form-radio>
                        <b-form-radio
                          value="One Time"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">One Time</span>
                        </b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group v-if="paymentMode === 'GIRO'">
                    <validation-provider
                      #default="{ errors }"
                      name="Payment Option"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="cardOption"
                        buttons
                        button-variant="outline-primary"
                        class="spaceBetweenRadio radiogGap10"
                        @change="onPaymentOptionChange"
                      >
                        <b-form-radio
                          value="Bank Transfer"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">Bank Transfer</span>
                        </b-form-radio>
                        <b-form-radio
                          value="PayNow"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">PayNow</span>
                        </b-form-radio>
                        <b-form-radio
                          value="Direct Debit"
                          class="register__payment-icon-checkbox"
                        >
                          <span class="register__payment-text">Direct Debit</span>
                        </b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group v-if="(paymentMode === 'Card' && ['IPP', 'Direct Debit', 'One Time'].includes(cardOption)) || (paymentMode === 'GIRO' && ['Direct Debit'].includes(cardOption))">
                    <validation-provider
                      #default="{ errors }"
                      name="Card"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="cardType"
                        buttons
                        button-variant="outline-primary"
                        class="spaceBetweenRadio radiogGap5"
                        @change="onCardTypeChange"
                      >
                        <b-form-radio
                          value="Visa Card"
                          class="register__payment-logo-checkbox"
                        >
                          <img
                            :src="visaIcon"
                            class="register__payment-logo-white"
                          >
                        </b-form-radio>
                        <b-form-radio
                          value="Master Card"
                          class="register__payment-logo-checkbox"
                        >
                          <img
                            :src="masterCardIcon"
                            class="register__payment-logo"
                          >
                        </b-form-radio>
                        <b-form-radio
                          value="Amex Card"
                          class="register__payment-logo-checkbox"
                        >
                          <img
                            :src="amexIcon"
                            class="register__payment-logo"
                          >
                        </b-form-radio>
                        <b-form-radio
                          value="China Union Pay"
                          class="register__payment-logo-checkbox"
                        >
                          <img
                            :src="unionPayIcon"
                            class="register__payment-logo"
                          >
                        </b-form-radio>
                        <b-form-radio
                          value="JCB"
                          class="register__payment-logo-checkbox"
                        >
                          <img
                            :src="jcbIcon"
                            class="register__payment-logo"
                          >
                        </b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label="Transaction Date*"
                    label-for="transactionDate"
                    label-class="register__payment-label"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Transaction Date"
                      vid="transactionDate"
                      rules="required"
                    >
                      <b-input-group>
                        <flat-pickr
                          id="transactionDate"
                          v-model="transactionDate"
                          class="form-control flat-pickr-group"
                          :config="{ wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true, maxDate: 'today' }"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label="Payment Reference*"
                    label-for="paymentReference"
                    label-class="register__payment-label"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Payment Reference"
                      vid="paymentReference"
                      rules="required"
                    >
                      <b-form-input
                        id="paymentReference"
                        v-model="paymentReference"
                        placeholder="Reference"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label="Remarks"
                    label-for="remarks"
                    label-class="register__payment-label"
                  >
                    <div
                      style="position: relative;"
                      class="mb-50"
                    >
                      <b-form-textarea
                        id="remarks"
                        v-model="remarks"
                        placeholder="Remarks"
                        maxlength="100"
                      />
                      <div style="position: absolute; bottom: 7px; color: #999999; right: 20px;">
                        {{ remarks.length }}/100
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>

            <b-nav class="wrap-border save-nav">
              <li class="nav-item ml-auto">
                <b-button
                  type="button"
                  variant="flat-primary"
                  :to="{ name: 'customers-orders-show', params: { id: $route.params.id } }"
                >
                  Cancel
                </b-button>
              </li>
              <li class="nav-item mr-1">
                <b-button
                  type="submit"
                  variant="success"
                  :disabled="invalid || !amountToBePaidIsValid"
                >
                  <feather-icon
                    icon="DollarSignIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">{{ isRefund ? 'Register Refund' : 'Register Payment' }}</span>
                </b-button>
              </li>
            </b-nav>
          </b-form>
        </validation-observer>
      </div>
    </b-card>

    <b-modal
      id="modal-confirm-register-payment"
      ref="confirm-register-payment-modal"
      modal-class="status-update-modal"
      centered
      no-close-on-backdrop
      hide-header
      @ok="submitPayment"
    >
      <div class="text-center py-1">
        <img
          :src="dollarPlusIcon2"
          class="mb-1"
        >
        <h4>Proceed to Register {{ isRefund ? 'Refund' : 'Payment' }}?</h4>
        <p class="text-muted">
          You are about to register a {{ isRefund ? 'refund' : 'payment' }} of
          <strong :class="isRefund ? 'text-danger' : 'text-success'">{{ isRefund ? '–' : '' }}S${{ numberFormat(Math.abs(amountToBePaid || 0)) }}</strong>
          for Order <strong>{{ order.stringID }}</strong> under <strong>{{ order.customerName }}</strong>.
        </p>
        <div class="important-note-box text-left">
          <h4><strong>Important note:</strong></h4>
          <div class="note_info">
            <p class="mb-0">
              This action only records the transaction; it does not process any payment or refund of funds. Please ensure that the actual payment or refund of funds is handled properly (outside of this system).
            </p>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          Proceed
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BRow, BCol, BCard, BCardText, BMedia, BMediaAside, BAvatar, BMediaBody, BForm, BFormGroup, BFormInput,
  BFormTextarea, BFormRadioGroup, BFormRadio, BFormInvalidFeedback, BInputGroup, BInputGroupAppend, BButton, BNav,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import { required } from '@validations'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BFormRadio,
    BFormInvalidFeedback,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BNav,
    ValidationObserver,
    ValidationProvider,
    flatPickr,
  },
  data() {
    return {
      required,
      // eslint-disable-next-line global-require
      dollarPlusIcon: require('@/assets/images/icons/payments/dollarPlus.png'),
      // eslint-disable-next-line global-require
      dollarPlusIcon2: require('@/assets/images/icons/Icon.svg'),
      // eslint-disable-next-line global-require
      handIcon: require('@/assets/images/icons/payments/hand.png'),
      // eslint-disable-next-line global-require
      cardIcon: require('@/assets/images/icons/payments/credit-card.svg'),
      // eslint-disable-next-line global-require
      dollarIcon: require('@/assets/images/icons/payments/dollar.svg'),
      // eslint-disable-next-line global-require
      giroIcon: require('@/assets/images/icons/payments/giro.svg'),
      // eslint-disable-next-line global-require
      netsIcon: require('@/assets/images/icons/payments/nets.svg'),
      // eslint-disable-next-line global-require
      chequeIcon: require('@/assets/images/icons/payments/cheque.svg'),
      // eslint-disable-next-line global-require
      visaIcon: require('@/assets/images/icons/payments/visa.svg'),
      // eslint-disable-next-line global-require
      masterCardIcon: require('@/assets/images/icons/payments/mastercard.svg'),
      // eslint-disable-next-line global-require
      amexIcon: require('@/assets/images/icons/payments/amex.svg'),
      // eslint-disable-next-line global-require
      unionPayIcon: require('@/assets/images/icons/payments/unionPay.svg'),
      // eslint-disable-next-line global-require
      jcbIcon: require('@/assets/images/icons/payments/jcb.svg'),

      order: { items: [] },
      paymentHistory: [],

      amountToBePaid: '',
      paymentMode: '',
      cardOption: '',
      cardType: '',
      transactionDate: moment().format('DD/MM/YYYY'),
      paymentReference: '',
      remarks: '',
      selectedRefundTransactionId: null,
    }
  },
  computed: {
    totalOutstanding() {
      return (this.order.totalPayable || 0) - (this.order.amountPaid || 0)
    },
    totalOutstandingLabel() {
      const sign = this.totalOutstanding < 0 ? '-' : ''
      return `${sign}S$${this.numberFormat(Math.abs(this.totalOutstanding))}`
    },
    isRefund() {
      return Number(this.amountToBePaid) < 0
    },
    amountToBePaidIsValid() {
      return Number(this.amountToBePaid) !== 0 && !Number.isNaN(Number(this.amountToBePaid))
    },
    refundableTransactions() {
      return this.paymentHistory.filter(trx => trx.status === 'Completed' && trx.amount > 0)
    },
    paymentReferenceLabel() {
      return this.cardType || this.cardOption || this.paymentMode
    },
  },
  mounted() {
    this.fetchOrderDetail()
  },
  methods: {
    fetchOrderDetail() {
      this.$http.get(`sales/retail-orders/${this.$route.params.id}/show`)
        .then(response => {
          this.order = response.data.data
          this.paymentHistory = response.data.paymentHistory

          const outstanding = (this.order.totalPayable || 0) - (this.order.amountPaid || 0)
          if (outstanding !== 0) {
            this.amountToBePaid = outstanding.toFixed(2)
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    onPaymentModeChange() {
      this.cardOption = ''
      this.cardType = ''
      this.paymentReference = ''
      if (this.paymentMode === 'Card') {
        this.cardOption = 'One Time'
        this.cardType = 'Visa Card'
      } else if (this.paymentMode === 'GIRO') {
        this.cardOption = 'Bank Transfer'
      }
    },
    onPaymentOptionChange() {
      this.cardType = ''
    },
    onCardTypeChange() {},
    openConfirmModal() {
      this.$refs.registerPaymentForm.validate().then(valid => {
        if (valid && this.amountToBePaidIsValid) {
          this.$root.$emit('bv::show::modal', 'modal-confirm-register-payment', '')
        }
      })
    },
    submitPayment() {
      const formData = new FormData()
      formData.append('type', this.isRefund ? 'refund' : 'payment')
      formData.append('paymentMode', this.paymentMode)
      formData.append('amount', Math.abs(this.amountToBePaid))
      formData.append('paymentReferenceLabel', this.paymentReferenceLabel)
      formData.append('paymentReferenceNo', this.paymentReference)
      formData.append('remarks', this.remarks)

      this.$http.post(`sales/retail-orders/${this.order._id}/payment/register`, formData)
        .then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({ name: 'customers-orders-show', params: { id: this.order._id }, hash: '#payment-summary' })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.refund-for-box {
  padding: 12px 16px;
  border-radius: 6px;
  background-color: #EEF1F8;
}

.important-note-box {
  margin-top: 1rem;
  padding: 12px 16px;
  border-radius: 6px;
  background-color: #FDEDED;
  border: 1px solid #F5C6CB;
  color: #EA5455;
  font-size: 0.85rem;
}
</style>
